import React, { useContext } from 'react';
import ProgressFullscreen from 'components/common/ProgressFullscreen';
import MarketSettingsForm from 'components/MarketSettings';
import { saveMarketSettings } from 'features/MarketSettingContainer/actions';
import useMarketSettings from 'features/PpsiContainer/hooks/useMarketSettings';
import { useDispatch } from 'react-redux';
import View from './views';

const MarketSettingsView = () => {
  const dispatch = useDispatch();
  const [isFetching, marketSettingsdata, fetchError] = useMarketSettings({
    forceFetch: true
  });

  function handleSave(data, callback) {
    const payload = { ...data }; // Create a shallow copy of data

    // const updatedUtensil = payload.localPPSIUtensils.map(item => {
    //   const newItem = { ...item };
    //   delete newItem.image; // Remove image property
    //   return newItem;
    // });

    // payload.localPPSIUtensils = updatedUtensil;
    dispatch(saveMarketSettings(payload, callback));
  }

  if (isFetching) {
    return <ProgressFullscreen open />;
  }
  View.MarketSetting.visit();
  return (
    <div>
      <MarketSettingsForm
        data={marketSettingsdata}
        onSave={handleSave}
        dataLabels={{
          modifiedBy: 'lastModifiedBy',
          modifiedDate: 'modifyDate'
        }}
      />
    </div>
  );
};

export default MarketSettingsView;
